import { Balance, CloseButton, CoinBar, Container, ImageContainer, ModalContainer, ModalSubTitle, ModalTitle, NewBalance, ProgressBar, RedeemButton, RewardBox, RewardContiner, RewardCost, RewardItem, RewardTop, StudentName, SubTitle, SuccessContainer, Title, TitleContainer } from "./RewardSide.styled";
import Coin_Icon from '@assets/svg/n_coin.svg';
import Reward_Icon from '@assets/svg/redeem/Coffee_icon.svg';
import Cross_Icon from '@assets/svg/match/missing.svg';
import Modal from "@components/Buttons/Modal";
import StudentThumbnail from "@components/StudentThumbnail";
import { useI18n } from '@i18n/useI18n';
import { useEffect, useRef, useState } from "react";
import RedeemSwipeNew from "@components/Buttons/RedeemSwipeNew";
import { useStore } from "@store/appStore";
import db from "@utils/db";
import Rewards from '@models/Rewards';


interface IProps{
    student: any;
    updatestudent: any;
}

const RewardSide = (props:IProps) =>{
    const i18n = useI18n();
    const {systemSettings, client } = useStore();
    const [openModal, setOpenModal] = useState(false);
    const [rewards, setRewards] = useState([]);
    const [selectedReward, setSelectedReward] = useState(null);
    const modalRef = useRef(null);
    const [error, setError] = useState(false);
    const [succes, setSucces] = useState(false);

    useEffect(() => {
        getData()
    }, [])

    const GetProgressPercent = (haveAmount, buyAmount) =>{
        if (buyAmount <= 0) return 0;
        const percent = (haveAmount / buyAmount) * 100;
        return Math.min(Math.max(percent, 0), 100);
    }

    let language = systemSettings.find((s) => s.APP_Setting_ID === 16);
    const getData = async () => {
        //let rewards = await db.GetRewards(language.value);
        let rewards = await db.Student_Stat_GetRewards(props.student.username, language.value);
        // console.log("rewards", rewards)
        setRewards(rewards);
    };

    const OpenModal = (reward) =>{
        setSelectedReward(reward)
        setOpenModal(true)
        //setError(true);
    }

    const CloseModal = () =>{
        setOpenModal(false)
        setSelectedReward(null)
        setError(false);
    }


    const getReward = async () => {
        let rewardCode = await db.MakeReward_Reservation(selectedReward.id, props.student.username, 5);
        if (rewardCode.length > 0) 
        {
            let codeCheck = await db.Redeem_Reward(client.UserName, rewardCode[0].qrCode);   
            props.updatestudent();         
            getData();
            setError(false);
            setSucces(true)
            setTimeout(() => {
                setOpenModal(false);
                setSucces(false)
            }, 5000);
        }
        else
        {
            //setError(true);
            setOpenModal(false);
        }
    }

    let Selected_Icon = null;

    if(selectedReward != null){
        Selected_Icon = Rewards[selectedReward.icon].icon;
    }    

    const getDisabledText = (stock, purchased_count, limit_pr_user, coins, cost) =>{
        if(coins < cost){
            return "not-enough-coins";
        }
        if(stock == 0){
            return "out-of-stock";
        }
        if(purchased_count >= limit_pr_user && limit_pr_user != -1){
            return "limit-reached-for-reward";
        }

        return "redeem";
    }

    return (<>
        {openModal?<Modal ref={modalRef} onClose={CloseModal} backColor={"rgba(0,0,0,0.25)"}>
            
                {succes? 
                <>
                    <SuccessContainer>
                        <CloseButton onClick={() => modalRef.current.handleClose()}><Cross_Icon /></CloseButton>
                        <ModalTitle>{i18n.t("redeem-succes")}</ModalTitle>
                        <br />
                        <ImageContainer>
                            <StudentThumbnail src={props.student?.username} name={props.student?.name} />
                        </ImageContainer>
                        <StudentName>{props.student?.name}</StudentName>
                        <RewardBox>
                            {selectedReward == null?null:<Selected_Icon />}
                            <span>{selectedReward.title}</span>
                        </RewardBox>
                        <br />
                        <ModalSubTitle>{i18n.t("redeem-succes-description")} <b>{selectedReward.title}</b> {i18n.t("for")} <p>"{props.student?.name}"</p></ModalSubTitle>
                    </SuccessContainer>
                </>
                :
                <ModalContainer>
                    <CloseButton onClick={() => modalRef.current.handleClose()}><Cross_Icon /></CloseButton>
                    <ModalTitle>{i18n.t("comfirm-redeem")}</ModalTitle>
                    <ModalSubTitle>{i18n.t("comfirm-details")}</ModalSubTitle>
                    <ImageContainer>
                        <StudentThumbnail src={props.student?.username} name={props.student?.name} />
                    </ImageContainer>
                    <StudentName>{props.student?.name}</StudentName>
                    {error?<>error</>:<>
                    <RewardBox>
                        {selectedReward == null?null:<Selected_Icon />}
                        <span>{selectedReward.title}</span>
                    </RewardBox>
                    <Balance>
                        <span>{i18n.t("current-coins")}</span>
                        <span><Coin_Icon /> {props.student?.coins}</span>
                    </Balance>
                    <RewardCost>
                        <span>{i18n.t("coin-cost")}</span>
                        <span><Coin_Icon /> {selectedReward.cost}</span>
                    </RewardCost>
                    <NewBalance>
                        <span>{i18n.t("new-coins")}</span>
                        <span><Coin_Icon /> {props.student?.coins - selectedReward.cost}</span>
                    </NewBalance>
                    <ModalSubTitle>{i18n.t("swipe-info")}</ModalSubTitle>
                    <RedeemSwipeNew handleSwipe={() => getReward()} /></>}
                </ModalContainer>}
            
        </Modal>:null}


        <Container>
            <TitleContainer>
                <Title>{i18n.t("attender-rewards")}</Title>
                <SubTitle>{i18n.t("redeem-reward-for")}</SubTitle>
            </TitleContainer>
            <RewardContiner>
                {rewards?.map((r, index) => {
                    let Icon = Rewards[r.icon].icon;
                    let percent = GetProgressPercent(props.student?.coins, r.cost);
                    let enough = false;

                    if(percent >= 100 && ((r.initial_stock - r.total_purchased_count) > 0 || r.initial_stock === -1) && (r.student_purchased_count < r.limit_pr_user || r.limit_pr_user === -1)){
                        enough = true;
                    }

                    let text = getDisabledText((r.initial_stock - r.total_purchased_count), r.student_purchased_count, r.limit_pr_user, props.student?.coins, r.cost);

                    return (
                        <RewardItem key={index + "_redeem_reward"} enable={enough}>
                            <RewardTop>
                                <span>{i18n.t("stock")}: {r.initial_stock === -1?<>&#8734;</>:(r.initial_stock - r.total_purchased_count)}</span>
                                <span>{r.student_purchased_count} / {r.limit_pr_user === -1?<>&#8734;</>:r.limit_pr_user}</span>
                            </RewardTop>
                            <Icon />
                            <span>{r.title}</span>
                            <CoinBar enable={enough}>
                                <span><Coin_Icon /> {props.student?.coins}</span>
                                <span>/</span>
                                <span>{r.cost}</span>
                            </CoinBar>
                            <ProgressBar progress={GetProgressPercent(props.student?.coins, r.cost)}><div /></ProgressBar>
                            <RedeemButton onClick={() => OpenModal(r)} enable={enough}><Coin_Icon />{i18n.t(text)}</RedeemButton>
                        </RewardItem>
                    )
                })}
            </RewardContiner>
        </Container>
    </>)
}

export default RewardSide;